document.addEventListener('DOMContentLoaded', function () {

  //get country geolocation (TD)
  $.get("https://ipinfo.io/json", function (response) {
    if (response['country']){
      lsStorage.cookie('countryCode',response['country'],{expires:365, path:'/'});
    }
  }); 
    
  //cookies popup
  var useCookies = lsStorage.cookie('useCookies');
  if (useCookies != '1'){
    $('#openCookie').removeClass('d-none');
  }
  $('#closeCookie').on('click',function(e){
   $('#openCookie').addClass('d-none');
   if (useCookies != '1'){
     lsStorage.cookie('useCookies','1',{expires:365, path:'/'});
   }
  });
  //whatsapp
  var badgemark = lsStorage.cookie('badgemark');
  if (badgemark != '1'){
    $('#notification-badge').css('display','flex');  
  }
  $('#whatsappchat-button').on('click',function(e){
   e.preventDefault;
   $('#notification-badge').hide();
   if (badgemark != '1'){
     lsStorage.cookie('badgemark','1',{expires:365, path:'/'});
   }
   return true;
  });

  //footer mobile collapsable menus
  $('.footer-menus .footer-link .module-title').on('click', function(){
    var elm = $(this).parent();
    if (!elm.hasClass('active')){
        $('.footer-menus .footer-link').removeClass('active');
    	elm.addClass('active');
    } else {
      	elm.removeClass('active');
    }
  });

  //mobile menu
  $('#on-canvas-button').on('click touchdown', function(e) {
  	if ($('#offcanvas').hasClass('active')) {
  		$('body,html').removeClass('off-canvas-active');
  		$('#offcanvas').removeClass('active');
  		$('.wrapper-container').removeClass('offcanvas-push');
  	} else {
  		$('body,html').addClass('off-canvas-active');
  		$('#offcanvas').addClass('active');
  		$('.wrapper-container').addClass('offcanvas-push');
  	}
  });

  function clear_accountcanvas() {
  	$('.tools-lang').removeClass('active');
  	$('.account-canvas').removeClass('active');
  }

  function clear_currencycanvas() {
  	$('.tools-curr').removeClass('active');
  	$('.currencies_w .currencies-top').removeClass('active');
  }

  $('#off-canvas-button').on('click touchdown', function(e) {
  	clear_accountcanvas();
  	clear_currencycanvas();
  	$('#offcanvas').removeClass('active');
  	$('.wrapper-container').removeClass('offcanvas-push');
  	$('body,html').removeClass('off-canvas-active');
  });
  $('.nm-page-overlay').on('click touchdown', function(e) {
  	clear_accountcanvas();
  	clear_currencycanvas();
  });

  $('.click-currency').on('click touchdown', function() {
  	clear_accountcanvas();
  	$(this).parent().toggleClass('active');
  	$(this).parent().find('.currencies-top').toggleClass('active');
  });

  $('.tools-lang').on('click touchdown', function() {
  	clear_currencycanvas();
  	$(this).toggleClass('active');
  	$('.account-canvas').toggleClass('active');
  });

  function showbox() {
  	$(".ajax-success-cbox").fadeIn(500);
  	var atTimeout = setTimeout(function() {
  		$(".ajax-success-cbox").fadeOut(300)
  	}, 5e3)
  }
  
  $(".close-cbox").click(function() {
  	clearTimeout(mt.atTimeout);
  	$(".ajax-success-cbox").fadeOut(500)
  })

  $('.save_cur').on('click', function() {
  	var elemental = $(this);
  	elemental.addClass("btn-loading").html('<svg class="icon-svg-spinner qb-spinner"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0v2c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8h2z"></path></svg></svg>');
  	setTimeout(function() {
  		elemental.html('<svg height="64px" width="64px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 55.702 55.702" xml:space="preserve" fill="#ffffff" stroke="#ffffff" stroke-width="0.00055702" style="width: 32px;height: 40px;display:inline-block;"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path style="fill:#ffffff;" d="M27.851,0C12.494,0,0,12.494,0,27.851s12.494,27.851,27.851,27.851s27.851-12.494,27.851-27.851 C55.701,12.494,43.208,0,27.851,0z M27.851,51.213c-12.882,0-23.362-10.48-23.362-23.363c0-12.882,10.48-23.362,23.362-23.362 s23.362,10.481,23.362,23.363S40.733,51.213,27.851,51.213z"></path> <path style="fill:#ffffff;" d="M36.729,18.97l-13,13.001l-4.757-4.757c-0.876-0.877-2.297-0.877-3.173,0 c-0.877,0.876-0.877,2.297,0,3.173l6.344,6.344c0.438,0.438,1.013,0.658,1.587,0.658s1.148-0.219,1.586-0.658l14.587-14.587 c0.876-0.877,0.876-2.297,0-3.174C39.026,18.094,37.606,18.094,36.729,18.97z"></path> </g> </g> </g></svg>');
  		setTimeout(function() {
  			elemental.removeClass("btn-loading").html('Save');
  		}, 550)
  	}, 350)
  });

  $(document).mouseup(function(e) {
  	var container = $("body #offcanvas");

  	if (!container.is(e.target) // if the target of the click isn't the container...
  		&&
  		container.has(e.target).length === 0) // ... nor a descendant of the container
  	{
  		$('body,html').removeClass('off-canvas-active');
  		$('body #offcanvas, .currencies_w .currencies-top').removeClass('active');
  		$('body .wrapper-container').removeClass('offcanvas-push');
  	}

  });

  $("#offcanvas .navbar-nav ul").hide();
  $('#offcanvas .navbar-nav li div').on('click touchdown', function(e) {
  	e.stopPropagation();
  	e.preventDefault();
  	icon = $(this).find('svg');
  	$(this).next().toggle();
  	if (icon.hasClass("flipped")) {
  		icon.removeClass("flipped");

  	} else {
  		icon.addClass("flipped");
  	}
  });
  
  $('#canvas-search').on('click touchdown', function(e) {
  	e.stopPropagation();
  	e.preventDefault();
  	$('#off-canvas-button').click();
  	if ($(window).width() > 768) {
  		$('body').addClass('active-search');
  		$('#search-top').addClass('active');
  		$('.search-form').fadeIn('100');
  	}
  	$('.search-form').show();
  	$('input[name="q"]').focus();
  });
  

  //$('a.dropdown-toggle[title="Shop"]').click();
  //$('ul.level-2 li.active').parent('ul').show();

  //applePay UAE notification
  if (/(Mac|iPad|iPhone|iPod)/g.test(navigator.userAgent)) {
    //$.get("https://ipinfo.io/json", function (response) {
      //window.countryCode = response['country'];
      //if (window.countryCode == 'AE') {

        $('.applePay_notice').show();
        /*
        $("a.continueAppleNotice").on('click', function (event) {
          $(this).addClass("btn-loading").html('<svg class="icon-svg-spinner qb-spinner"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0v2c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8h2z"></path></svg></svg>');
        });
        $(".view-checkout a.btn.harman_btn5").on('click', function (event) {
          if (lsStorage.cookie('applePayNotice') == 'done') {
            return true;
          } else {
            event.preventDefault;
            $('.ajax-success-cbox').addClass('popit');
            lsStorage.cookie('applePayNotice', 'done', {
              expires: 365,
              path: '/'
            });
            return false;
          }
        });
        */
        
    
      //}
    //});
  }

  //desktop header handler
  document.activeElement.blur();
  $('.nm-page-overlay').click(function () {
    $(".continue-shoping a").click();
  });

  if ($(window).width() > 1024) {
    void 0 !==  $('.cbImgs').each(function() {
      var $img = $(this);
      if (!$img.length) return;
      $img.attr('src', $img.data('src'));
    });
  }

  function showMenu(elem) {
    elem.addClass("hovered");
    $('.header').removeClass('header-opacity');
    $('.dropdown-overlay').show();
  }
  
  function hideMenu(elem) {
    elem.removeClass("hovered");
    $('.dropdown-overlay').hide();
    if (window.headerOpacity) $('.header').addClass('header-opacity');
  }

  function hideAllMenus() {
    $("li.megamenu-dropdow").removeClass("hovered");
    $('.dropdown-overlay').hide();
    if (window.headerOpacity) $('.header').addClass('header-opacity');
  }

  function activate_mm() {
    $('.icon-search').on('click touchend', function () {
      hideAllMenus();
      $('.quick-search-overlay').show();
      $(this).addClass('open-search').hide();
      $('.header-cart-container.closed-search').removeClass('closed-search').addClass('open-search');
      setTimeout(function () {
        $('.header-cart-container.open-search input[name="q"]').focus()
      }, 100);
    });
    $('.header-cart-container #Search').focusin(function () {
      $('.quick-search-overlay').show();
    });

    $("li.megamenu-dropdow a").on('click', function (e) {
      var elem = $(this).parent('li');
      elem.find('.icon-caret-down').toggleClass('flipped');
      if (elem.hasClass('hovered')) {
        e.stopPropagation();
        hideMenu(elem);
      } else {
        hideAllMenus();
        showMenu(elem);
      }

    });

    $('.dropdown-overlay').click(function (e) {
      hideAllMenus();
    })

    $('.header').click(function (e) {
      if ($(e.target).hasClass('header-cart-container') || $(e.target).is('.header-cart-container i') || $(e.target).hasClass('pre-currencies')) {
        hideAllMenus();
      }
    })

    $('.search-close,body').click(function (e) {
      if (!$('body').hasClass('active-search')) return;
      if (!$(e.target).closest('#search-top').length || $(this).is('#closepadsearch')) {
        $('body').removeClass('active-search');
        $('#search-top').removeClass('active');
        return false;
      };
    });
    $('.quick-search-overlay').on('click', function () {
      $('#predictive-search').hide();
      $('.quick-search-overlay').hide();
      $('.icon-search').removeClass('open-search').show();
      $('.header-cart-container.open-search').removeClass('open-search').addClass('closed-search');
    });
    $(".dropdown-sub").hover(
      function () {
        $(this).parent().addClass("has_arrow");
      },
      function () {
        $(this).parent().removeClass("has_arrow");
      }
    );
    $(".dropdown-subs").hover(
      function () {
        $(this).parent().addClass("sub-hovered");
      },
      function () {
        $(this).parent().removeClass("sub-hovered");
      }
    );
    /*
    $(document).mouseup(function (e){
      var container = $("#dropdown-cart");
      if (!container.is(e.target) // if the target of the click isn't the container...
      && container.has(e.target).length === 0) { // ... nor a descendant of the container
        if ($('#dropdown-cart').hasClass('active')) {
          $('#dropdown-cart').removeClass('active');
          $('.wrapper-container').removeClass('show-cart');
          $('body').css( "overflow", "visible" );
        }
      }
    });
    */
    $('.icon-search').on('click touchend', function (e) {
      e.stopPropagation();
      e.preventDefault();
      $('#off-canvas-button').click();
      $('.search-form').fadeIn('300');
      $('.overlay-search').css({
        "display": "block",
        "transform": "scale(1, 1)"
      });
    });
    $('.search-close').on('click touchend', function () {
      $('.search-form').fadeOut('300');
      $('.overlay-search').removeAttr("style");
    });
  }
  
  activate_mm();  
  
  fixFlickity();

  if (window.annoucement > 1) annoucementSlider();
  
  //pages menu
  if (window.template == 'page') {
     $('.open-tray').on('click touchdown',function(e){
       e.preventDefault;
       e.stopPropagation;
       var the_parent = $('.care.page-left-col');
       if (!the_parent.hasClass('active')){
       		the_parent.addClass('active');
         	$('.open-tray-svg').attr('class','open-tray-svg btn-arrow-left');
       }
       else{
         	the_parent.removeClass('active');
         	$('.open-tray-svg').attr('class','open-tray-svg btn-arrow-right');
         	
       }
       
     });    
  }

  //plus/minus for main cart page
  if (window.template == 'cart') {
      $(".cart-plusminus").click(function(n) {
      	var key = $(this).attr("data-id");
      	var quantity = $(this).attr("data-quantity");
      	var control = $(this).parents('.cart-quantity');

      	$.ajax({
      		type: "post",
      		url: "/cart/change.js",
      		data: "id=" + key + "&quantity=" + quantity,
      		dataType: "json",
      		beforeSend: function() {
      			control.addClass('loading');
      		},
      		success: function(n) {
      			location.reload();
      		},
      		error: function(n, r) {
      			control.removeClass('loading');
      			$(".ajax-error-message").text($.parseJSON(n.responseText).description);
      			showPopupBox(".ajax-error-cbox");
      		}
      	})

      });
  }

  console.log('[Hello.] Welcome to sauce. Enjoy :)');
});

var allowRecentlyViewed = true;
var hashCheck = window.location.hash;
if (hashCheck && hashCheck == '#footer_newsletter') {
    allowRecentlyViewed = false;
    var formTo =  document.querySelector(hashCheck);
    var hashTop = formTo.offsetTop;
    window.scrollTo({ top:hashTop, left:0, behavior: "instant"});
    setTimeout(function() { $('.cf_first_name').focus(); }, 100);
}
          
function showPopupBox(n) {
  $(n).fadeIn(500);
  setTimeout(function() {
    $(n).fadeOut(300)
  }, 5e3);
}

//cookie replacement via localstorage
if (typeof lsStorage === "undefined") {
  var lsStorage = {}
}
lsStorage.cookie = function(name,data,virtualDate) {
  if (data) {
    localStorage.setItem(name, data);
  } else {
    var storageCookie = localStorage.getItem(name) || false;
    return storageCookie;
  }
};

//multi-currency
if (window.show_multiple_currencies) {
  // Can be 'money_format' or 'money_with_currency_format'
  Currency.format = 'money_format';
  var shopCurrency = window.shop_currency;
  var cookieCurrency = Currency.cookie.read();
  var buttons = $('.currencies_ul a');
  var currentCurrencies = $('.pre-currencies');
  var lowShopCurrency = window.shop_currency.toLowerCase();
  
  // Fix for customer account pages 
  $('span.money span.money').each(function() {
  	$(this).parent('span.money').removeClass('money');
  });
  
  // Saving the current price 
  $('span.money').each(function() {
  	$(this).attr('data-currency-' + lowShopCurrency, $(this).html());
  });
  
  // When the page loads.
  if (cookieCurrency == null || cookieCurrency == shopCurrency || cookieCurrency == '') {
    Currency.currentCurrency = shopCurrency;
  	currentCurrencies.html($('.pre-load-current').html());
  } else if (cookieCurrency === shopCurrency) {
  	Currency.currentCurrency = shopCurrency;
  	currentCurrencies.html($('.pre-load-current').html());
  } else {
  	Currency.convertAll(shopCurrency, cookieCurrency);
  	//Currency.currentCurrency) = cookieCurrency;
  
  	buttons.removeClass('selected');
  	$('.currencies_ul a[data-currency=' + cookieCurrency + ']').addClass('selected');
  	var htmlCurrently = $('.currencies_ul a[data-currency=' + cookieCurrency + ']').html();
  	currentCurrencies.html(htmlCurrently);
  
  	do_multi_currency_warning(Currency.currentCurrency, shopCurrency);
  }
  
  buttons.click(function() {
  	var newCurrency = $(this).attr('data-currency');
  	var htmlCurrently = $(this).html();
  
  	buttons.removeClass('selected');
  	$(this).addClass('selected');
  	currentCurrencies.html(htmlCurrently);
  
  	Currency.convertAll(Currency.currentCurrency, shopCurrency);
  	Currency.convertAll(shopCurrency, newCurrency);
  
  	do_multi_currency_warning(Currency.currentCurrency, shopCurrency);
    localStorage.setItem('currency', newCurrency);
  	return false;
  });
  
  // do this each time you recalculate or page load
  do_multi_currency_warning(Currency.currentCurrency, shopCurrency);
  
  function do_multi_currency_warning(currentCurrency, shopCurrency) {
  	$('.selected-currency').text(Currency.currentCurrency);
  	if (currentCurrency != shopCurrency) {
  		$('p.currency_warning').show();
  	} else {
  		$('p.currency_warning').hide();
  	}
  }
    
  $(function() {
  	$('.currencies li a').on('click', function() {
  		$('.pre-currencies').attr('data-currency', $(this).data('currency'));
  	});
  });

  setTimeout(function() {
    if (cookieCurrency !='') return;
    
    var countryCurrency =  lsStorage.cookie('countryCode');
    if (countryCurrency == false || countryCurrency == 'BE') return;
    
    var euCountriesCheck = /AT|BE|HR|CY|EE|FI|FR|DE|GR|IE|IT|LV|LT|LU|MT|NL|PT|SK|SI|ES/.test(countryCurrency);
    if (euCountriesCheck == true) countryCurrency = 'EU';
    $('.ajax-success-cbox').addClass('showCurrencyMsg');

    var buttonCountry = '';

    switch (countryCurrency) {
      case "SA":
        buttonCountry = document.querySelector("[data-currency='SAR']");
        break;
      case "KW":
        buttonCountry = document.querySelector("[data-currency='KWD']");
        break;
      case "UK":
        buttonCountry = document.querySelector("[data-currency='GBP']");
        break;
      case "EU":
        buttonCountry = document.querySelector("[data-currency='EUR']");
        break;
      default:
        buttonCountry = document.querySelector("[data-currency='USD']");
    }
 
    buttonCountry.click();
    //show a popup explaining currencies
     $("a.continueAppleNotice").on('click', function (event) {
       $('.ajax-success-cbox').removeClass('showCurrencyMsg');
     });
  }, 500);
    
  
}

//wishlist
var LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
var LOCAL_STORAGE_DELIMITER = ',';
var BUTTON_ACTIVE_CLASS = 'active';
var GRID_LOADED_CLASS = 'loaded';

var selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
};

document.addEventListener('DOMContentLoaded', function () {
  initButtons();
  initGrid();
});

document.addEventListener('shopify-wishlist:updated', function (event) {
  //console.log('[Shopify Wishlist] Wishlist Updated ✅', event.detail.wishlist);
  initGrid();
});
/*
document.addEventListener('shopify-wishlist:init-product-grid', function (event) {
  console.log('[Shopify Wishlist] Wishlist Product List Loaded ✅', event.detail.wishlist);
});

document.addEventListener('shopify-wishlist:init-buttons', function (event) {
  console.log('[Shopify Wishlist] Wishlist Buttons Loaded ✅', event.detail.wishlist);
});
*/
var setupGrid = function (grid) {
  var wishlist = getWishlist();
  wishlist = wishlist.reverse();
  var requests = wishlist.map(function (handle) {
    var productTileTemplateUrl = '/products/' + handle + '?view=card';
    return fetch(productTileTemplateUrl).then(function (res) {
      if (res.status == 404) return;
      return res.text();
    });
  });
  Promise.all(requests).then(function (responses) {
    if (responses.length == 0) {
       grid.innerHTML = '<p class="noWishlist">You\'re Wishlist is empty :(.</p>';
    }
    else {
      var wishlistProductCards = responses.join('');   
      var wishlistProductCards_fixed = wishlistProductCards.replace(/grid-item product-item/gi, "grid-item product-item col-lg-3 col-md-4 col-6 product-items");
    
      grid.innerHTML = wishlistProductCards_fixed;
    }
    
    grid.classList.add(GRID_LOADED_CLASS);
    initButtons();

    var event = new CustomEvent('shopify-wishlist:init-product-grid', {
      detail: { wishlist: wishlist }
    });
    document.dispatchEvent(event);
  });
};

var toggle = function (e) {
  var txt = e.innerText;
  e.innerText = txt == 'Remove from Wishlist' ? 'Add to Wishlist' : 'Remove from Wishlist';
}

var setupButtons = function (buttons) {
  buttons.forEach(function (button) {
    var productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
   
    var textSpan = document.querySelector("span.wishlist-text");

    if (wishlistContains(productHandle)) { 
      button.classList.add(BUTTON_ACTIVE_CLASS);  
      if (textSpan) textSpan.innerText = 'Remove from Wishlist';        
    } 
    button.addEventListener('click', function () {      
      updateWishlist(productHandle);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
      if (textSpan) toggle(textSpan);
    });
  });
};

var initGrid = function () {
  var grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};

var initButtons = function () {
  var buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;
  var event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
};

var getWishlist = function () {
  var wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

var setWishlist = function (array) {
  var wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  var event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });
  document.dispatchEvent(event);

  return wishlist;
};

var updateWishlist = function (handle) {
  var wishlist = getWishlist();
  var indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

var wishlistContains = function (handle) {
  var wishlist = getWishlist();
  return wishlist.indexOf(handle) !== -1;
};

var resetWishlist = function () {
  return setWishlist([]);
};

//recentlyviewed
var LOCAL_STORAGE_RV_KEY = 'recently-viewed';
var MAX_RV = (typeof maxRecentlyViewed !== 'undefined') ? maxRecentlyViewed:8;

if (allowRecentlyViewed === true) {
  document.addEventListener('DOMContentLoaded', function () {
    RVinitGrid();
  });
}
var setupRVGrid = function (RVgrid) {
  var recentlyviewed = getRecentlyViewed();
  //check if empty return  
  if (!recentlyviewed.length)  { 
    console.log('empty');
    return
  }
  //discard product ur currently on
  if (window.template == 'product') {
    var indexInRecentlyViewed = recentlyviewed.indexOf(product.handle);
    if (indexInRecentlyViewed !== -1) {
      if (recentlyviewed.length == 1) return;
      recentlyviewed.splice(indexInRecentlyViewed, 1);
    }
  }
  //show from newest to oldest
  recentlyviewed = recentlyviewed.reverse();
  var rvrequests = recentlyviewed.map(function (handle) {
    var productTileTemplateUrl = '/products/' + handle + '?view=card';
    return fetch(productTileTemplateUrl).then(function (res) {
      if (res.status == 404) return;
      return res.text();
    });
  });
  Promise.all(rvrequests).then(function (responses) {
    if (responses.length == 0) {
        console.log('[Recently Viewed] Empty');
    }
    else {
      var recentlyviewedProductCards = responses.join('');   
      var recentlyviewedProductCards_fixed = recentlyviewedProductCards.replace(/grid-item product-item/gi, "grid-item carousel-cell");
    
      RVgrid.innerHTML = recentlyviewedProductCards_fixed;  
      applyFlickity();
    }
    
    RVgrid.classList.add(GRID_LOADED_CLASS);
  });
};

var applyFlickity = function() {
        var recentViewedSlider = new FlickityResponsive('.main-carousel-rv', {
        	accessibility: false,
        	freeScroll: true,
        	contain: true,
        	dragThreshold: 15,
        	selectedAttraction: 0.01,
        	friction: 0.15,
        	freeScrollFriction: 0.04,
        	pageDots: false,
        	lazyLoad: false,
        	responsiveNavigation: true,
        	cellAlign: 'left',
        	groupCells: 4,
        	responsive: [{
        			breakpoint: 743,
        			settings: {
        				prevNextButtons: false,
        				groupCells: 1,
        				contain: false,
        				cellAlign: 'center'
        			}
        		},
        		{
        			breakpoint: 1024,
        			settings: {
        				groupCells: 2
        			}
        		},
        		{
        			breakpoint: 1280,
        			settings: {
        				groupCells: 3
        			}
        		}
        	]
        });
        $(".recently-viewed-products .related-heading").show();
         
        $('#recently-viewed-products-grid img').on('load',function(){this.classList.add('img-loaded');});
  
        if (window.show_multiple_currencies) {
          $('#recently-viewed-products-grid div.prices span.money').each(function() {      
          	$(this).attr('data-currency-' + product.lower_currency, $(this).html());
          });
          
          Currency.convertAll(window.shop_currency, $('.currencies_ul .currency.selected').data('currency'));
        }        
}

var RVinitGrid = function () {
  var RVgrid = document.getElementById('recently-viewed-products-grid') || false;
  if (RVgrid) setupRVGrid(RVgrid);
};

var getRecentlyViewed = function () {
  var recentlyviewed = localStorage.getItem(LOCAL_STORAGE_RV_KEY) || false;
  if (recentlyviewed) {
    var rvTemp = recentlyviewed.split(LOCAL_STORAGE_DELIMITER);
    if (rvTemp.length > MAX_RV) rvTemp.splice(0, 1);
    return rvTemp;
  }
  return [];
};

var setRecentlyViewed = function (array) {
  var recentlyviewed = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_RV_KEY, recentlyviewed);

  var event = new CustomEvent('recently-viewed:updated', {
    detail: { recentlyviewed: array }
  });
  document.dispatchEvent(event);

  return recentlyviewed;
};

var updateRecentlyViewed = function (handle) {
  var recentlyviewed = getRecentlyViewed();
  var indexInRecentlyViewed = recentlyviewed.indexOf(handle);

  if (indexInRecentlyViewed !== -1) recentlyviewed.splice(indexInRecentlyViewed, 1);
  recentlyviewed.push(handle);
  return setRecentlyViewed(recentlyviewed);
};

var resetRecentlyViewed = function () {
  return getRecentlyViewed([]);
};


/* ========================================================================
 * Bootstrap: collapse.js v3.0.3
 * http://getbootstrap.com/javascript/#collapse
 * ========================================================================
 * Copyright 2013 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ======================================================================== */


!function ($) { "use strict";

  // COLLAPSE PUBLIC CLASS DEFINITION
  // ================================

  var Collapse = function (element, options) {
    this.$element      = $(element)
    this.options       = $.extend({}, Collapse.DEFAULTS, options)
    this.transitioning = null

    if (this.options.parent) this.$parent = $(this.options.parent)
    if (this.options.toggle) this.toggle()
  }

  Collapse.DEFAULTS = {
    toggle: true
  }

  Collapse.prototype.dimension = function () {
    var hasWidth = this.$element.hasClass('width')
    return hasWidth ? 'width' : 'height'
  }

  Collapse.prototype.show = function () {
    if (this.transitioning || this.$element.hasClass('in')) return

    var startEvent = $.Event('show.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    var actives = this.$parent && this.$parent.find('> .panel > .in')

    if (actives && actives.length) {
      var hasData = actives.data('bs.collapse')
      if (hasData && hasData.transitioning) return
      actives.collapse('hide')
      hasData || actives.data('bs.collapse', null)
    }

    var dimension = this.dimension()

    this.$element
      .removeClass('collapse')
      .addClass('collapsing')
      [dimension](0)

    this.transitioning = 1

    var complete = function () {
      this.$element
        .removeClass('collapsing')
        .addClass('in')
        [dimension]('auto')
      this.transitioning = 0
      this.$element.trigger('shown.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    var scrollSize = $.camelCase(['scroll', dimension].join('-'))

    this.$element
      .one($.support.transition.end, $.proxy(complete, this))
      .emulateTransitionEnd(350)
      [dimension](this.$element[0][scrollSize])
  }

  Collapse.prototype.hide = function () {
    if (this.transitioning || !this.$element.hasClass('in')) return

    var startEvent = $.Event('hide.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    var dimension = this.dimension()

    this.$element
      [dimension](this.$element[dimension]())
      [0].offsetHeight

    this.$element
      .addClass('collapsing')
      .removeClass('collapse')
      .removeClass('in')

    this.transitioning = 1

    var complete = function () {
      this.transitioning = 0
      this.$element
        .trigger('hidden.bs.collapse')
        .removeClass('collapsing')
        .addClass('collapse')
    }

    if (!$.support.transition) return complete.call(this)

    this.$element
      [dimension](0)
      .one($.support.transition.end, $.proxy(complete, this))
      .emulateTransitionEnd(350)
  }

  Collapse.prototype.toggle = function () {
    this[this.$element.hasClass('in') ? 'hide' : 'show']()
  }


  // COLLAPSE PLUGIN DEFINITION
  // ==========================

  var old = $.fn.collapse

  $.fn.collapse = function (option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.collapse')
      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  $.fn.collapse.Constructor = Collapse


  // COLLAPSE NO CONFLICT
  // ====================

  $.fn.collapse.noConflict = function () {
    $.fn.collapse = old
    return this
  }


  // COLLAPSE DATA-API
  // =================

  $(document).on('click.bs.collapse.data-api', '[data-toggle=collapse]', function (e) {
    var $this   = $(this), href
    var target  = $this.attr('data-target')
        || e.preventDefault()
        || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') //strip for ie7
    var $target = $(target)
    var data    = $target.data('bs.collapse')
    var option  = data ? 'toggle' : $this.data()
    var parent  = $this.attr('data-parent')
    var $parent = parent && $(parent)

    if (!data || !data.transitioning) {
      if ($parent) $parent.find('[data-toggle=collapse][data-parent="' + parent + '"]').not($this).addClass('collapsed')
      $this[$target.hasClass('in') ? 'addClass' : 'removeClass']('collapsed')
    }

    $target.collapse(option)
  })

}(jQuery);

//fix for flickity
function fixFlickity() {
	if (
		window.template != 'product' &&
		window.template != 'index' &&
		window.template != 'cart') return;

	//if (!/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) return;

	//console.log('flickityFix - Started');

	var touchingCarousel = false;
	var startXCoordinate;

	document.body.addEventListener('touchstart', e => {
		if (e.target.closest('.flickity-slider')) {
			touchingCarousel = true;
		} else {
			touchingCarousel = false;
			return;
		}
		startXCoordinate = e.touches[0].pageX;
	})

	document.body.addEventListener('touchmove', e => {
		if (
			!touchingCarousel ||
			!e.cancelable ||
			Math.abs(e.touches[0].pageX - startXCoordinate) < 8
		) return;
		e.preventDefault();
	}, {
		passive: false
	})

	/* prevent resize in flickity if still animating */
    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) {
    	var resize = Flickity.prototype.resize;
    	Flickity.prototype.resize = function() {
    		if (!this.isAnimating) {
    			resize.call(this);
    		}
    	};
    }
}

//popup newsletter
(function () {
    var allowedPages = ['index','collection','product','cart','page'];
    var pageIndex = allowedPages.indexOf(window.template);

    if (pageIndex === -1) {
      return;
    }

    if(typeof popUpNewsletter[window.template] !== "undefined" && popUpNewsletter[window.template] == false){
      return;      
    } 

    if(popUpNewsletter['hide_on_mobile'] == true && window.innerWidth < 992){
      return;      
    } 

	var $popupwapper = $('#wapper-popup');
	var popupnewsletter = $('#popup-newsletter');

	$popupwapper.css({
		'position': 'relative'
	});

	$('.wrapper #popup-newsletter').remove();

	$popupwapper.append(popupnewsletter);

	if (lsStorage.cookie('emailpopup') != 'closed') {
		setTimeout(function() {
			openNewsletter();
		}, 2000);
	};
  
	$('#popup-newsletter .btn.close').click(function(e) {
		e.preventDefault();
		closeNewsletter();
	});

	function closeNewsletter() {
		$('#popup-newsletter .popupnewsletter').fadeOut(300, function() {
			$('#popup-newsletter .popup-overlay').fadeOut(300, function() {
				$('#popup-newsletter').hide();
				lsStorage.cookie('emailpopup', 'closed');
			});
		})
	}
  
	function openNewsletter() {
		$('#popup-newsletter').fadeIn(300, function() {
			$('#popup-newsletter .popupnewsletter').fadeIn(300);
		});
	}
  
    /*
    $(document).mouseup(function (e){
      var container = $(".popupnewsletter");

	  if (!container.is(e.target) && container.has(e.target).length === 0){
    	  e.preventDefault();
    	  closepopup();
	  }
	}); 
    */
})(); 

//form handler
function formToJSON(elements) {
	return [].reduce.call(elements, function(data, element) {
		data[element.name] = element.value;
		return data;
	}, {});
}

function subFormLoader(form) {
    form.addEventListener('submit', function(e) {
    	e.preventDefault();

        //honeypotting
        var assal = this.querySelector('.business_name');

        if (assal.value !== null && assal.value !== '') {
          return false;
        }

        if (assal.value !== null) assal.remove();
      
        var button = this.querySelector('[type="submit"]');
      	var form_type = this.querySelector("[name=form_type]").value;
		var inputs = this.querySelectorAll("[name]");
        var JSONinputs = formToJSON(inputs);

      	//if (submitting == true) {
			//return;
		//}
      
        button.classList.add('btn-loading');
        if (button.tagName == 'BUTTON') {
          button.innerHTML += ' <svg class="icon-svg-spinner tempLoader" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0v2c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8h2z"></path></svg>';
        } else 
          button.value = "Loading ...";
        button.disabled = true;

		//submitting = true;

        setTimeout(function(){
          form.submit();
        },100)        
    });
  
}
//var submitting = false;
document.querySelectorAll(".contact_form, .custSet").forEach(function(el) {
	subFormLoader(el);
});


//annoucement slider
function annoucementSlider() {
  var $annoucement = $('.announcement-carousel');

  if (!$annoucement.length) return;

  var timing = parseInt($annoucement.data('timeout'));

  var flickConfig = {
    accessibility: false,
    freeScroll: false,
    dragThreshold: 15,
    draggable: false,
    selectedAttraction: 0.015,
    friction: 0.30,
    lazyLoad: false,
    pauseAutoPlayOnHover: true,
    wrapAround: false,
    groupCells: false,
    prevNextButtons: true,
    pageDots: false,
    autoPlay: timing,
    cellAlign: 'center',
    contain: true,
    cellSelector: '.announcement-bar-item'
  } 
  
  if (window.template == 'collection' && typeof $annoucement.flickity !== "function") { 
    var scriptEl = loadJS(window.annoucement_script);
    scriptEl.addEventListener("load", function() {
      $annoucement.flickity(flickConfig);
    })
  }
   else {
    $annoucement.flickity(flickConfig);
  } 
}

//load a js
function loadJS(FILE_URL) {
  var scriptEle = document.createElement("script");

  scriptEle.setAttribute("src", FILE_URL);
  scriptEle.setAttribute("type", "text/javascript");

  document.body.appendChild(scriptEle);

  return scriptEle;
}
//sections.init
function stringToBoolean(stringValue) {
  switch(stringValue?.toLowerCase()?.trim()){
    case "true": 
    return true;
      case "false": 
    case null: 
    case undefined:
      return false;
    default: 
      return JSON.parse(stringValue);
  }
}

var sectionsInit;
! function($) {
  "use strict";
  sectionsInit = function() { 
    return {
      init: function() {
        this.shopCarousel();
        this.slider();
        this.showHomeVideos();
      },
      shopCarousel: function() {          
          void 0 !==  $(".slider.carousel-head").each(function(index) {
            var $carousel = $(this);
            
            var id = this.dataset.id;           
            var showButtons = stringToBoolean(this.dataset.button);
            var showDots = stringToBoolean(this.dataset.dots);
            var autoplayCheck = stringToBoolean(this.dataset.autoplay); 
            var wrap = false;
            if (autoplayCheck == true) {
              var autoplay = parseInt(this.dataset.speed) * 1000;
              var cellAlign = 'left';
              var contain = true;
              var limit = parseInt(this.dataset.limit);
            } else {
              var autoplay = false;
              var cellAlign = this.dataset.center;
              var contain = stringToBoolean(this.dataset.contain);
              var limit = 1;
            }
            
            $carousel.on( 'ready.flickity', function() {           
              $('.carousel-move-text-'+id).css('display','grid').detach().prependTo('#'+id+' .flickity-viewport');
            });
          
            $carousel.flickity({                  
                  accessibility: false,
                  freeScroll: true,
                  dragThreshold:15,
                  selectedAttraction: 0.01,
                  friction: 0.15,
                  freeScrollFriction: 0.04,
                  lazyLoad: false,
                  pauseAutoPlayOnHover: false,
                  wrapAround: wrap,
                  groupCells: limit,
                  prevNextButtons: showButtons,
                  pageDots: showDots,
                  autoPlay: autoplay,
                  cellAlign: cellAlign,
                  contain: contain
            });
          });
      
      },
      slider: function() {  
        var sliderParent = $('.home-slider.main-brand');
        if (sliderParent.length && sliderParent.is(':visible')) {
            
          void 0 !==  $(".slide.home-slider").each(function(index) {
            var slider = $(this);
            
            var id = this.dataset.id;    
            var sliderType = this.dataset.type;
            var showButtons = stringToBoolean(this.dataset.button);
            var showDots = stringToBoolean(this.dataset.dots);
            var autoplayCheck = stringToBoolean(this.dataset.autoplay); 
            var wrap = false; 
            if (autoplayCheck == true) {
              var autoplay = parseInt(this.dataset.speed) * 1000;
            }
            else {
              var autoplay = false;
            }
            var cellAlign = 'left';
            var contain = true;
            var initialIndex = 0;
            var cellLimit = 1; //parseInt(this.dataset.limit);
            if (sliderType == 'split') {
              cellAlign = 'center';
              contain = false;
              wrap = true;
              initialIndex = 1;
            }
                   
            slider.flickity({                  
                  accessibility: false,
                  freeScroll: true,
                  dragThreshold:15,
                  selectedAttraction: 0.07,
                  friction: 0.5,
                  freeScrollFriction: 0.04,
                  lazyLoad: false,
                  pauseAutoPlayOnHover: false,
                  wrapAround: wrap,
                  groupCells: cellLimit,
                  prevNextButtons: showButtons,
                  pageDots: showDots,
                  autoPlay: autoplay,
                  cellAlign: cellAlign,
                  contain: contain,
                  initialIndex: initialIndex
            });
          }); 
        }
      },
      showHomeVideos: function() {
          var bgv = $('.home-videos');
          if (bgv.is(':visible')) {
            $('source', bgv).each(
              function() {
                var el = $(this);
                el.attr('src', el.data('src'));
                
              }
            );
            bgv.load();
          }        
      }      
    }     
  }()
}(jQuery), 
$(document).ready(function() {
  if (window.sections_draw === false) return;
  sectionsInit.init()   
});
if (Shopify.designMode) {
  $(document).on("shopify:section:load", sectionsInit.shopCarousel).on("shopify:section:unload", sectionsInit.shopCarousel).on("shopify:section:select", sectionsInit.shopCarousel).on("shopify:section:deselect", sectionsInit.shopCarousel).on("shopify:block:select", sectionsInit.shopCarousel).on("shopify:block:deselect", sectionsInit.shopCarousel);  
  $(document).on("shopify:section:load", annoucementSlider).on("shopify:section:unload", annoucementSlider).on("shopify:section:select", annoucementSlider).on("shopify:section:deselect", annoucementSlider).on("shopify:block:select", annoucementSlider).on("shopify:block:deselect", annoucementSlider);
  $(document).on("shopify:section:load", sectionsInit.slider).on("shopify:section:unload", sectionsInit.slider).on("shopify:section:select", sectionsInit.slider).on("shopify:section:deselect", sectionsInit.slider).on("shopify:block:select", sectionsInit.slider).on("shopify:block:deselect", sectionsInit.slider);
  $(document).on("shopify:section:load", sectionsInit.showHomeVideos).on("shopify:section:unload", sectionsInit.showHomeVideos).on("shopify:section:select", sectionsInit.showHomeVideos).on("shopify:section:deselect", sectionsInit.showHomeVideos).on("shopify:block:select", sectionsInit.showHomeVideos).on("shopify:block:deselect", sectionsInit.showHomeVideos);
}
//jQuery passive events fix
$.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
$.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
$.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
$.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

  
